// extracted by mini-css-extract-plugin
export default {"loading":"E5rXoh1Rj_ksvM4ZJQ6K","text":"DGBueJwhXs1LvOKIpxY8","keyword":"IiUTJcSKG5MH03Lc3mAz"};